jQuery($ => {
    class Panel_Meganav {
      constructor(element) {
        this._             = element;
        this._element      = $(element);
        this._focusableEls = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
        this._focusables   = this._element.find(this._focusableEls);
        this._column       = this._element.find('.m-panel-meganav__column');

        this._overview           = this._element.find('.m-panel-meganav__column--overview');
        this._overviewFocusables = this._overview.find(this._focusableEls);

        this._panel1        = this._element.find('.m-panel-meganav__column--panels .m-panel-menu__panel--1');
        this._panel1Options = this._panel1.find('.m-menu-options');
        this._panelMenu     = this._element.find('.m-panel-menu');

        this._feature           = this._element.find('.m-panel-meganav__column--feature');
        this._featureFocusables = this._feature.find(this._focusableEls);
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        function debounce(func, delay) {
          let timer;
          return function() {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, arguments), delay);
          };
        }

        this._overviewFocusables.on('keydown', this.handleOverviewKeydown);
        this._panel1Options.on('keyToEdge', debounce(this.handleMenuKeyToEdge, 100));
        this._featureFocusables.on('keydown', debounce(this.handleFeatureKeydown, 100));
        this._panelMenu.on('change', debounce(this.handlePanelMenuChange, 100));
        // this._element.on('reset', debounce(this.handleReset, 100));
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reset
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReset = () => {
        this._element.find('.m-panel-menu__panel--open').closest('.m-panel-menu').trigger('reset');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Panel Menu Change
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handlePanelMenuChange = () => {
        this._element.trigger('change');
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Menu Key-To-Edge
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleMenuKeyToEdge = (event, direction) => {
        switch (direction) {
          case 'left':
            const $panel       = $(event.currentTarget).closest('.m-panel-menu__panel');
            const controlledby = $panel.data('controlledby');
            const $controller  = $(`#${controlledby}`);
            
            $controller.focus();
            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Overview Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleOverviewKeydown = event => {
        const target = event.currentTarget;
        const index = this._overviewFocusables.index(target);

        switch (event.key) {
          case 'ArrowRight':
            event.preventDefault();

            if ($(target).attr('aria-controls')) {
              $(target).trigger('click');
            } else {
              const $openPanel           = this._element.find('.m-panel-meganav__column--panels .m-panel-menu__panel--1.m-panel-menu__panel--open');
              const $openPanelFocusables = $openPanel.find(this._focusableEls);
  
              $openPanelFocusables.first().focus();
            }

            break;

          case 'ArrowUp':
            event.preventDefault();
            
            const prevIndex = index - 1;

            if (prevIndex >= 0) {
              this._overviewFocusables.eq(prevIndex).focus();
            } else {
              this._overviewFocusables.last().focus();
            }

            break;

          case 'ArrowDown':
            event.preventDefault();

            const nextIndex = index + 1;

            if (nextIndex <= this._overviewFocusables.length - 1) {
              this._overviewFocusables.eq(nextIndex).focus();
            } else {
              this._overviewFocusables.first().focus();
            }

            break;
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Feature Keydown
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleFeatureKeydown = event => {
        const index = this._featureFocusables.index(event.currentTarget);

        switch (event.key) {
          case 'ArrowLeft':
            const $focusable = this._menuFocusables[0]
              ? this._menuFocusables.last()
              : this._overviewFocusables[0]
                ? this._overviewFocusables.last()
                : null;
            
            if (!$focusable) return;
            
            event.preventDefault();
            $focusable.focus();
            break;

          case 'ArrowUp':
            event.preventDefault();
            
            const prevIndex = index - 1;

            if (prevIndex >= 0) {
              this._featureFocusables.eq(prevIndex).focus();
            } else {
              this._featureFocusables.last().focus();
            }

            break;

          case 'ArrowDown':
            event.preventDefault();

            const nextIndex = index + 1;

            if (nextIndex <= this._featureFocusables.length - 1) {
              this._featureFocusables.eq(nextIndex).focus();
            } else {
              this._featureFocusables.first().focus();
            }

            break;
        }
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.panel_meganav = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].panel_meganav = new Panel_Meganav(_[i], opt);
        else
          ret = _[i].panel_meganav[opt].apply(_[i].panel_meganav, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-panel-meganav').panel_meganav();
});